import { FC, useEffect, useState } from 'react'
import { UsContract } from 'modules/domain/usContracts/types'
import { defaultTheme, Icons, Text } from '@agro-club/agroclub-shared'
import { useTranslation } from 'react-i18next'
import { Card } from 'views/components/Card/Card'
import styled from 'styled-components'
import { RequestError } from 'modules/errors'

const WarningSign = styled(Icons.IconExclamationCircle)`
  width: 16px;
  height: 16px;
  path {
    fill: ${defaultTheme.color.accentOrange600};
  }
`

const Message = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
`

type Props = {
  contract: UsContract
}

export const SignWarnings: FC<Props> = ({ contract }) => {
  const { t } = useTranslation('usContracts')
  const needCLWarning = !contract.is_credit_limit_met && !contract.approved_credit_limit_overdraft
  const needPLWarning = !contract.is_position_limit_met && !contract.approved_position_limit_overdraft

  if (!needCLWarning && !needPLWarning) {
    return null
  }

  return (
    <Card.Container intent="warning" style={{ padding: '8px 12px' }}>
      <div style={{ display: 'flex', flexDirection: 'column', gap: '6px' }}>
        {needCLWarning && (
          <Message>
            <WarningSign /> <Text typography="bodyMedium">{t('creditLimitExceedWarning')}</Text>
          </Message>
        )}
        {needPLWarning && (
          <Message>
            <WarningSign /> <Text typography="bodyMedium">{t('positionLimitExceedWarning')}</Text>
          </Message>
        )}
      </div>
    </Card.Container>
  )
}

const CloseBtn = styled(Icons.IconClose)`
  width: 18px;
  height: 18px;
  position: absolute;
  right: 16px;
  top: 50%;
  transform: translate(0, -50%);
  cursor: pointer;
`

// we need error object to have referrece check in useEffect
export const SignError: FC<{ error: ReturnType<typeof RequestError.parseError> | null }> = ({ error }) => {
  const [isOpen, setIsOpen] = useState(!!error)

  useEffect(() => {
    setIsOpen(!!error)
  }, [error])

  if (!isOpen) {
    return null
  }

  return (
    <Card.Container intent="danger" style={{ padding: '8px 12px' }}>
      <CloseBtn onClick={() => setIsOpen(false)} />
      <Text typography="bodyMedium">{error?.detail}</Text>
    </Card.Container>
  )
}
